import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TareasService } from './../../services/tareas.service';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CasosTareasComponent } from './casos/casos.component';
import { CasosDashboard } from './casos-dashboard/dash.component';
import { CasosRoutingModule } from './casos.routing';
import { CrearCasoTareasComponent } from './crear-caso/c-caso.component';
import { DetalleCaso } from './detalle-caso/detalle-caso.component';
import { AgregarTareasComponent } from './agregar-tareas/agregar-tareas.component';
import { VerHistorialComponent } from './ver-historial/ver-historial.component';
import { VerTareaComponent } from './ver-tarea/ver-tarea.component';
import { CasosArchivadosComponent } from './casos-archivados/casos-archivados.component';
import { ObservacionFinalComponent } from './observacion-final/observacion-final.component';
import { CasosAprobarComponent } from './casos-aprobar/casos-aprobar.component';
import { NoAprobarComentario } from './no-aprobar-comentario/no-aprobar-comentario';
import { ComponentDirective } from './ver-tarea/directive/component.directive';
import { SuministroInformacionComponent } from './ver-tarea/components/suministro-de-informacion/suministro-informacion/suministro-informacion.component';
import { ConfirmarActividadIrregularComponent } from './ver-tarea/components/grupos-vip/confirmar-actividad-irregular/confirmar-actividad-irregular.component';
import { InformeAccionIrregularComponent } from './ver-tarea/components/grupos-vip/informe-accion-irregular/informe-accion-irregular.component';
import { ContactoGerenteComponent } from './ver-tarea/components/grupos-vip/contacto-gerente/contacto-gerente.component';
import { InformeResultadoComponent } from './ver-tarea/components/grupos-vip/informe-resultado/informe-resultado.component';
import { AsignarUsuarioModalComponent } from './crear-caso/asignar-usuario-modal/asignar-usuario-modal.component';
import { ComentarioSolicitarRevisionComponent } from './detalle-caso/comentario-solicitar-revision/comentario-solicitar-revision.component';
import { SelectFilterComponent } from './casos/select-filter/select-filter.component';
import { RegistrarRelacionMontosSalvadosComponent } from './ver-tarea/components/retencion-de-fondos/registrar-relacion-montos-salvados/registrar-relacion-montos-salvados.component';
import { SolicitudRecaudosComponent } from './ver-tarea/components/asuntos-internos/recuperacion-de-fondos-cuentas-externas/solicitud-recaudos/solicitud-recaudos.component';
import { DatosFiliatoriosComponent } from './ver-tarea/components/asuntos-internos/investigacion/datos-filiatorios/datos-filiatorios.component';
import { ReporteDelitosInformaticosComponent } from './ver-tarea/components/asuntos-internos/investigacion/reporte-delitos-informaticos/reporte-delitos-informaticos.component';
import { DireccionAntecedentesLaboralesComponent } from './ver-tarea/components/asuntos-internos/investigacion/direccion-antecedentes-laborales/direccion-antecedentes-laborales.component';
import { DatosResidencialesComponent } from './ver-tarea/components/asuntos-internos/investigacion/datos-residenciales/datos-residenciales.component';
import { OrigenAsignacionCasoInvestigacionComponent } from './ver-tarea/components/asuntos-internos/investigacion/origen-asignacion-caso-investigacion/origen-asignacion-caso-investigacion.component';
import { DatosMigratoriosComponent } from './ver-tarea/components/asuntos-internos/investigacion/datos-migratorios/datos-migratorios.component';
import { CuentasOtrosBancosComponent } from './ver-tarea/components/asuntos-internos/investigacion/cuentas-otros-bancos/cuentas-otros-bancos.component';
import { InteraccionRedesSocialesComponent } from './ver-tarea/components/asuntos-internos/investigacion/interaccion-redes-sociales/interaccion-redes-sociales.component';
import { RastreoMovimientosBancariosComponent } from './ver-tarea/components/asuntos-internos/investigacion/rastreo-movimientos-bancarios/rastreo-movimientos-bancarios.component';
import { ComentarioCasoComponent } from './detalle-caso/comentario-caso/comentario-caso.component';
import { AprobacionEvaluacionEspecialistaComponent } from './ver-tarea/components/asuntos-internos/investigacion/aprobacion-evaluacion-especialista/aprobacion-evaluacion-especialista.component';
import { EvaluacionInicialCasoComponent } from './ver-tarea/components/grupos-vip/evaluacion-inicial-caso/evaluacion-inicial-caso.component';
import { HistorialComponent } from './detalle-caso/historial/historial.component';
import { VerificarTransferenciaInterbancariaComponent } from './ver-tarea/components/asuntos externos/autorizarTransacciones/verificar-transferencia-interbancaria/verificar-transferencia-interbancaria.component';
import { VerificarEmisionChequeGerenciaComponent } from './ver-tarea/components/asuntos externos/autorizarTransacciones/verificar-emision-cheque-gerencia/verificar-emision-cheque-gerencia.component';
import { ValidarTransaccionesComponent } from './ver-tarea/components/asuntos externos/autorizarTransacciones/validar-transacciones/validar-transacciones.component';
import { CompletarDatosAutorizarTransaccionesComponent } from './ver-tarea/components/asuntos externos/autorizarTransacciones/completar-datos-autorizar-transacciones/completar-datos-autorizar-transacciones.component';
import { InformacionEmpleadosComponent } from './ver-tarea/components/asuntos-internos/investigacion/informacion-empleados/informacion-empleados.component';
import { CompletarValidacionDocumentoComponent } from './ver-tarea/components/asuntos externos/validacion-documento/completar-validacion-documento/completar-validacion-documento.component';
import { ValidacionDeDocumentoComponent } from './ver-tarea/components/asuntos externos/validacion-documento/validacion-de-documento/validacion-de-documento.component';
import { CrearSolicitudValidacionRefComponent } from './ver-tarea/components/asuntos externos/validacion-referencia/crear-solicitud-validacion-ref/crear-solicitud-validacion-ref.component';
import { ValidacionReferenciaComponent } from './ver-tarea/components/asuntos externos/validacion-referencia/validacion-referencia/validacion-referencia.component';
import { CrearSolicitudAlertaComponent } from './ver-tarea/components/asuntos externos/rol-guardia/crear-solicitud-alerta/crear-solicitud-alerta.component';
import { SeguimientoDocumentoIrregularComponent } from './ver-tarea/components/asuntos externos/validacion-documento/seguimiento-documento-irregular/seguimiento-documento-irregular.component';
import { PerquisaRolGuardiaComponent } from './ver-tarea/components/asuntos externos/rol-guardia/perquisa-rol-guardia/perquisa-rol-guardia.component';
import { InformePreliminarComponent } from './ver-tarea/components/asuntos externos/rol-guardia/informe-preliminar/informe-preliminar.component';
import { PersonalInternoInvolucradoRolComponent } from './ver-tarea/components/asuntos externos/rol-guardia/personal-interno-involucrado-rol/personal-interno-involucrado-rol.component';
import { AsesoriaGerenteServiciosComponent } from './ver-tarea/components/asuntos externos/rol-guardia/asesoria-gerente-servicios/asesoria-gerente-servicios.component';
import { CasoRoboHurtoComponent } from './ver-tarea/components/asuntos externos/rol-guardia/caso-robo-hurto/caso-robo-hurto.component';
import { ElevaAdministracionSegurosComponent } from './ver-tarea/components/asuntos externos/rol-guardia/eleva-administracion-seguros/eleva-administracion-seguros.component';
import { DatosCandidatoComponent } from './ver-tarea/components/asuntos externos/investigacion-empleo/datos-candidato/datos-candidato.component';
import { VerificacionSaimeComponent } from './ver-tarea/components/asuntos externos/investigacion-empleo/verificacion-saime/verificacion-saime.component';
import { VerificacionCandidatoComponent } from './ver-tarea/components/asuntos externos/investigacion-empleo/verificacion-candidato/verificacion-candidato.component';
import { SolicitudReintegroComponent } from './ver-tarea/components/asuntos-internos/recuperacion-de-fondos-cuentas-externas/solicitud-reintegro/solicitud-reintegro.component';
import { ConfirmacionRecuperoFondosComponent } from './ver-tarea/components/asuntos-internos/recuperacion-de-fondos-cuentas-externas/confirmacion-recupero-fondos/confirmacion-recupero-fondos.component';
import { DeterminarProcedenciaDelCaso } from './ver-tarea/components/deteccionyanalisisfraudes/determinar-procedencia-del-caso/determinar-procedencia-del-caso.component';
import { DetalleTransaccionalDelCaso } from './ver-tarea/components/deteccionyanalisisfraudes/detalle-transaccional-del-caso/detalle-transaccional-del-caso.component';
import { ReclamosMediosMagneticos } from './ver-tarea/components/deteccionyanalisisfraudes/reclamos/reclamos-medios-magneticos/reclamos-medios-magneticos.component';
import { ReclamosMediosNOMagneticos } from './ver-tarea/components/deteccionyanalisisfraudes/reclamos/reclamos-medios-no-magneticos/reclamos-medios-no-magneticos.component';
import { ClassifyRasComponent } from './ver-tarea/components/ras/classify-ras/classify-ras.component';
import { TaskCardComponent } from './detalle-caso/task-card/task-card.component';
import { DeteccionFraudesComentarioComponent } from './detalle-caso/deteccion-fraude/comentario/comentario.component';
import { DeteccionFraudesAprobarCasoComponent } from './detalle-caso/deteccion-fraude/aprobar-caso/aprobar-caso.component';
import { DeteccionFraudesBotonSolicitarRevisionComponent } from './detalle-caso/deteccion-fraude/boton-solicitar-revision/boton-solicitar-revision.component';
import { DeteccionFraudesBotonAprobarCasoComponent } from './detalle-caso/deteccion-fraude/boton-aprobar-caso/boton-aprobar-caso.component';
import { DeteccionFraudesAprobarCasoModalComponent } from './detalle-caso/deteccion-fraude/aprobar-caso-modal/aprobar-caso-modal.component';
import { ConfirmDeleteComponent } from './detalle-caso/secondary-information/case-files/confirm-delete/confirm-delete.component';
import { AnalyzeRasComponent } from './ver-tarea/components/ras/analyze-ras/analyze-ras.component';
import { CreateCaseFilesComponent } from './crear-caso/create-case-files/create-case-files.component';
import { PersonInvolvedRasComponent } from './ver-tarea/components/ras/person-involved-ras/person-involved-ras.component';
import { NaturalFormComponent } from './ver-tarea/components/ras/person-involved-ras/natural-form/natural-form.component';
import { LegalFormComponent } from './ver-tarea/components/ras/person-involved-ras/legal-form/legal-form.component';
import { DescriptionRasComponent } from './ver-tarea/components/ras/description-ras/description-ras.component';
import { OtherPersonComponent } from './ver-tarea/components/ras/description-ras/other-person/other-person.component';
import { DescriptionRasDateComponent } from './ver-tarea/components/ras/description-ras/description-ras-date/description-ras-date.component';
import { DescriptionRasTypeOfReportComponent } from './ver-tarea/components/ras/description-ras/description-ras-type-of-report/description-ras-type-of-report.component';
import { DescriptionRasCurrencyComponent } from './ver-tarea/components/ras/description-ras/description-ras-currency/description-ras-currency.component';
import { RegisterHypothesisRasComponent } from './ver-tarea/components/ras/register-hypothesis-ras/register-hypothesis-ras.component';
import { ConfirmDeleteRasComponent } from './ver-tarea/components/ras/confirm-delete-ras/confirm-delete-ras.component';
import { InstrumentDescriptionComponent } from './ver-tarea/components/ras/description-ras/instrument-description/instrument-description.component';
import { OthersInstrumentsComponent } from './ver-tarea/components/ras/description-ras/others-instruments/others-instruments.component';
import { HypothesisFormRasComponent } from './ver-tarea/components/ras/register-hypothesis-ras/hypothesis-form-ras/hypothesis-form-ras.component';
import { EvidenceFormRasComponent } from './ver-tarea/components/ras/register-hypothesis-ras/evidence-form-ras/evidence-form-ras.component';
import { HypothesisValuesFormRasComponent } from './ver-tarea/components/ras/register-hypothesis-ras/hypothesis-values-form-ras/hypothesis-values-form-ras.component';
import { AskApprovalComponent } from './detalle-caso/case-information/ask-approval/ask-approval.component';
import { DeterminarProcedenciaFraudeComponent } from './ver-tarea/components/gestion-administrativa-fraude/determinar-procedencia-fraude/determinar-procedencia-fraude.component';
import { ElaborarInformePesquisaComponent } from './ver-tarea/components/retencion-de-fondos/elaborar-informe-pesquisa/elaborar-informe-pesquisa.component';
import { EvaluacionPesquisaComponent } from './ver-tarea/components/asuntos-internos/investigacion/evaluacion-pesquisa/evaluacion-pesquisa.component';
import { OperationsAndInstrumentsRelatedToRASComponent } from './ver-tarea/components/ras/operations-and-instruments-related-to-ras/operations-and-instruments-related-to-ras.component';
import { PeopleRelatedToTheRASComponent } from './ver-tarea/components/ras/people-related-to-the-ras/people-related-to-the-ras.component';
import { SucursalRasComponent } from './ver-tarea/components/ras/sucursal-ras/sucursal-ras.component';

const caseComponents = [
  // CaseCommentComponent,
  // CaseRecordComponent,
  // CaseFilesComponent,
  // CaseInformationComponent,
  // SecondaryInformationComponent,
  TaskCardComponent,
  // RecordItemComponent,
  // CommentItemComponent,
  // FileItemComponent,
  ConfirmDeleteComponent,
  AskApprovalComponent,
];

const rasComponents = [
  PersonInvolvedRasComponent,
  ClassifyRasComponent,
  AnalyzeRasComponent,
  NaturalFormComponent,
  LegalFormComponent,
  DescriptionRasComponent,
  OtherPersonComponent,
  DescriptionRasDateComponent,
  DescriptionRasTypeOfReportComponent,
  DescriptionRasCurrencyComponent,
  RegisterHypothesisRasComponent,
  SucursalRasComponent,
  ConfirmDeleteRasComponent,
  InstrumentDescriptionComponent,
  OthersInstrumentsComponent,
  HypothesisFormRasComponent,
  EvidenceFormRasComponent,
  HypothesisValuesFormRasComponent,
];
@NgModule({
  declarations: [
    CasosTareasComponent,
    CasosDashboard,
    CreateCaseFilesComponent,
    CrearCasoTareasComponent,
    DetalleCaso,
    AgregarTareasComponent,
    VerHistorialComponent,
    VerTareaComponent,
    CasosArchivadosComponent,
    ObservacionFinalComponent,
    CasosAprobarComponent,
    NoAprobarComentario,
    ComponentDirective,
    SuministroInformacionComponent,
    DatosFiliatoriosComponent,
    ReporteDelitosInformaticosComponent,
    DireccionAntecedentesLaboralesComponent,
    DatosResidencialesComponent,
    OrigenAsignacionCasoInvestigacionComponent,
    EvaluacionPesquisaComponent,
    DatosMigratoriosComponent,
    CuentasOtrosBancosComponent,
    InteraccionRedesSocialesComponent,
    RastreoMovimientosBancariosComponent,
    ConfirmarActividadIrregularComponent,
    InformeAccionIrregularComponent,
    ContactoGerenteComponent,
    InformeResultadoComponent,
    AsignarUsuarioModalComponent,
    ComentarioSolicitarRevisionComponent,
    SelectFilterComponent,
    RegistrarRelacionMontosSalvadosComponent,
    ElaborarInformePesquisaComponent,
    SolicitudRecaudosComponent,
    ComentarioCasoComponent,
    AprobacionEvaluacionEspecialistaComponent,
    EvaluacionInicialCasoComponent,
    HistorialComponent,
    VerificarTransferenciaInterbancariaComponent,
    VerificarEmisionChequeGerenciaComponent,
    ValidarTransaccionesComponent,
    CompletarDatosAutorizarTransaccionesComponent,
    InformacionEmpleadosComponent,
    CompletarValidacionDocumentoComponent,
    ValidacionDeDocumentoComponent,
    CrearSolicitudValidacionRefComponent,
    ValidacionReferenciaComponent,
    CrearSolicitudAlertaComponent,
    SeguimientoDocumentoIrregularComponent,
    PerquisaRolGuardiaComponent,
    InformePreliminarComponent,
    PersonalInternoInvolucradoRolComponent,
    AsesoriaGerenteServiciosComponent,
    CasoRoboHurtoComponent,
    ElevaAdministracionSegurosComponent,
    DatosCandidatoComponent,
    VerificacionSaimeComponent,
    VerificacionCandidatoComponent,
    SolicitudReintegroComponent,
    ConfirmacionRecuperoFondosComponent,
    DeterminarProcedenciaDelCaso,
    DetalleTransaccionalDelCaso,
    ReclamosMediosMagneticos,
    ReclamosMediosNOMagneticos,
    ...rasComponents,
    ...caseComponents,
    DeteccionFraudesComentarioComponent,
    DeteccionFraudesAprobarCasoComponent,
    DeteccionFraudesBotonSolicitarRevisionComponent,
    DeteccionFraudesBotonAprobarCasoComponent,
    DeteccionFraudesAprobarCasoModalComponent,
    DeterminarProcedenciaFraudeComponent,
    OperationsAndInstrumentsRelatedToRASComponent,
    PeopleRelatedToTheRASComponent,
    SucursalRasComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    CommonModule,
    CasosRoutingModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [TareasService],
})
export class CasosModule {}
